import { IRectangleCoordinatable } from "../../../base/domain/drawing";
import { IFormatSpecification } from "./IFormatSpecification";
import { IEditableFormatObject } from "./IEditableFormatStructure";
import { IFormatObjectEditable } from "./IFormatObjectEditable";
import {
  ElementTypes,
  ITextObject,
  IDateObject,
  ITagObject,
  IScriptObject,
  IScriptLinkObject,
  ICalculateObject,
  IJoinTextObject,
  ICheckObject,
  ICircleSelectObject,
  IComboObject,
  IRollObject,
  IImageAreaObject,
  IImageObject,
  IGraphObject,
  IBarcodeObject,
  IPositionCorrectionObject,
  ILineObject,
  IBoxLineObject,
  ICircleObject,
} from "./objects";
import {
  TextObjectEditor,
  DateObjectEditor,
  TagObjectEditor,
  ScriptObjectEditor,
  ScriptLinkObjectEditor,
  CalculateObjectEditor,
  JoinTextObjectEditor,
  CheckObjectEditor,
  CircleSelectObjectEditor,
  ComboObjectEditor,
  RollObjectEditor,
  ImageAreaObjectEditor,
  ImageObjectEditor,
  GraphObjectEditor,
  BarcodeObjectEditor,
  PositionCorrectionObjectEditor,
  LineObjectEditor,
  BoxLineObjectEditor,
  CircleObjectEditor,
  NotImplementedObjectEditor,
} from "./objectEditors";

export class FormatObjectEditorFactory {
  constructor(private readonly _specification: IFormatSpecification) {
    this._factories = this.createFactories();
  }

  private readonly _factories: { [key in ElementTypes]: (s: IEditableFormatObject, isNew: boolean) => IFormatObjectEditable };

  private createFactories(): { [key in ElementTypes]: (s: IEditableFormatObject, isNew: boolean) => IFormatObjectEditable } {
    return {
      text: (s, isNew) => new TextObjectEditor(s as ITextObject, this._specification, isNew),
      date: (s, isNew) => new DateObjectEditor(s as IDateObject, this._specification, isNew),
      tag: (s, isNew) => new TagObjectEditor(s as ITagObject, this._specification, isNew),
      script: (s, isNew) => new ScriptObjectEditor(s as IScriptObject, this._specification, isNew),
      scriptlink: (s, isNew) => new ScriptLinkObjectEditor(s as IScriptLinkObject, this._specification, isNew),
      calculate: (s, isNew) => new CalculateObjectEditor(s as ICalculateObject, this._specification, isNew),
      jointext: (s, isNew) => new JoinTextObjectEditor(s as IJoinTextObject, this._specification, isNew),
      check: (s, isNew) => new CheckObjectEditor(s as ICheckObject, this._specification, isNew),
      circleselect: (s, isNew) => new CircleSelectObjectEditor(s as ICircleSelectObject, this._specification, isNew),
      combo: (s, isNew) => new ComboObjectEditor(s as IComboObject, this._specification, isNew),
      roll: (s, isNew) => new RollObjectEditor(s as IRollObject, this._specification, isNew),
      imagearea: (s, isNew) => new ImageAreaObjectEditor(s as IImageAreaObject, this._specification, isNew),
      image: (s, isNew) => new ImageObjectEditor(s as IImageObject, this._specification, isNew),
      stamp: null,            // Docu2Web未実装.E大でも使わないので優先度は低.
      graph: (s, isNew) => new GraphObjectEditor(s as IGraphObject, this._specification, isNew),
      embed: null,            // Claioシェーマ使わないので優先度は低.
      sign: null,             // Docu2Web未実装.E大でも使わないので優先度は低.
      barcode: (s, isNew) => new BarcodeObjectEditor(s as IBarcodeObject, this._specification, isNew),
      poscorrect: (s, isNew) => new PositionCorrectionObjectEditor(s as IPositionCorrectionObject, this._specification, isNew),
      richText: null,         // E大に出荷してるファイル版にはないので優先度は低.
      newPage: null,          // E大に出荷してるファイル版にはないので優先度は低.
      watermark: null,        // DMO用なので優先度は低.
      variablearea: null,     // DMO用なので優先度は低.
      line: (s, isNew) => new LineObjectEditor(s as ILineObject, this._specification, isNew),
      boxline: (s, isNew) => new BoxLineObjectEditor(s as IBoxLineObject, this._specification, isNew),
      circle: (s, isNew) => new CircleObjectEditor(s as ICircleObject, this._specification, isNew),
      triangle: null,         // 最新版でもフォーマット編集には機能なし.優先度低.
      cross: null,            // 最新版でもフォーマット編集には機能なし.優先度低.
    };
  }

  private getFactory(key: ElementTypes): (s: IEditableFormatObject, isNew: boolean) => IFormatObjectEditable {
    return this._factories[key]
      ? this._factories[key]
      : (s, isNew) => new NotImplementedObjectEditor(s as (IEditableFormatObject & IRectangleCoordinatable), this._specification, isNew);
  }

  create(source: IEditableFormatObject, isNew: boolean = false): IFormatObjectEditable {
    return (source !== null)
      ? this.getFactory(source.elementName)(source, isNew)
      : null;
  }
}
